<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5">
<h1 class="tochead"><span class="bold">CONTENTS</span></h1>
</a><h2 class="toc1"><a id="page_5"></a><a href="#/xhtml/05_Introduction">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Chapter01"><span class="bold">Chapter 1</span></a></h2>
<h3 class="toc"><a href="#/xhtml/06_Chapter01#sec1">Merchant Ship Crews and Basic Seamanship</a></h3>
<h2 class="toc"><span href="#/xhtml/07_Chapter02" title="Link target outside of Sample"><span class="bold">Chapter 2</span></span></h2>
<h3 class="toc"><span href="#/xhtml/07_Chapter02#sec2" title="Link target outside of Sample">The Merchant Navy at War</span></h3>
<h2 class="toc"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample"><span class="bold">Chapter 3</span></span></h2>
<h3 class="toc"><span href="#/xhtml/08_Chapter03#sec3" title="Link target outside of Sample">Merchant Ship Defence</span></h3>
<h2 class="toc"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample"><span class="bold">Chapter 4</span></span></h2>
<h3 class="toc"><span href="#/xhtml/09_Chapter04#sec4" title="Link target outside of Sample">Convoys and Escorts</span></h3>
<h2 class="toc"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample"><span class="bold">Chapter 5</span></span></h2>
<h3 class="toc"><span href="#/xhtml/10_Chapter05#sec5" title="Link target outside of Sample">Safety and Survival</span></h3>
<h2 class="toc2"><span href="#/xhtml/11_Sources" title="Link target outside of Sample">Sources</span></h2>
<a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?403a5759